module.exports = __webpack_public_path__ + "static/media/about-img-5@2x.86eb2b88.png";